import { useParentingSpace } from "hooks/useParentingSpace";
import React from "react"; 
import { useState } from "react"
import { Button, Form, FormGroup, Input, Label, Spinner } from "reactstrap";
import PropTypes from 'prop-types';

    export default function InviteForm( {setModal}) {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { inviteToParentingSpace } = useParentingSpace();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
        await inviteToParentingSpace(email, role); 
        setEmail("");
        setRole("");
        if (setModal) setModal(false);
        } catch (error) {
        console.error("Error inviting to parenting space:", error);  
        } finally {
        setIsLoading(false);
        }
    };

  return (
    <Form onSubmit={handleSubmit} className="mx-auto p-4   rounded shadow"  >
      <FormGroup>
        <Label for="email">Email address</Label>
        <Input
          id="email"
          type="email"
          placeholder="parent@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </FormGroup>
      <FormGroup>
        <Label for="role">Role</Label>
        <Input
          type="select"
          id="role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        >
          <option value="" disabled>
            Select a role
          </option>
          <option value="lawyers">Lawyers</option>
          <option value="mediators">Mediators</option>
          <option value="parenting_coordinators">Parenting Coordinators</option>
          <option value="parents">Parents</option>
          <option value="therapists">Therapists</option>
        </Input>
      </FormGroup>
      <Button type="submit" color="primary" block disabled={isLoading}>
        {isLoading ? <Spinner size="sm" /> : "Send Invite"}
      </Button>
    </Form>
  );
}

InviteForm.propTypes = {
    setModal: PropTypes.func,  
};
